import React, {useEffect} from 'react';
import BackOfficeMenu from '../components/BackOfficeMenu';
import Profile from '../../FrontOffice/profile/Profile';
import {usePermissions} from '../../utils/usePermissions';
import './ProfileAdmin.css';

const ProfileAdmin = ({onNavigate, onLogout, currentPage}) => {
  const {permissions, typeUser} = usePermissions();

  useEffect(() => {
    if (typeUser && typeUser !== 'admin' && typeUser !== 'moderateur') {
      onNavigate('profile');
      return;
    }
  }, [onNavigate, typeUser]);

  // Grouper les permissions par module pour un affichage plus propre
  const groupedPermissions = permissions.reduce((acc, p) => {
    const [module, action] = p.split(':');
    if (!acc[module]) acc[module] = [];
    acc[module].push(action);
    return acc;
  }, {});

  return (
    <div className="profile-admin-container">
      <BackOfficeMenu
        onNavigate={onNavigate}
        onLogout={onLogout}
        currentPage={currentPage}
      />
      <div className="profile-admin-content">
        <div className="profile-header-card">
          <Profile onLogout={onLogout} isAdmin={true} />

          {typeUser === 'moderateur' && (
            <div className="moderator-permissions-section">
              <h3 className="section-title">
                <i className="fas fa-shield-alt"></i> Mes Permissions (Modérateur)
              </h3>
              <div className="permissions-grid-display">
                {Object.entries(groupedPermissions).length > 0 ? (
                  Object.entries(groupedPermissions).map(([module, actions]) => (
                    <div key={module} className="permission-module-card">
                      <h4 className="module-name">{module}</h4>
                      <div className="actions-list">
                        {actions.map(action => (
                          <span key={action} className={`action-badge ${action}`}>
                            {action}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="no-permissions">Aucune permission spécifique n'a été attribuée.</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileAdmin;
